import { SwapOutlined } from '@ant-design/icons';
import { history, useAccess } from '@umijs/max';
import { Tooltip } from 'antd';
import React from 'react';
import {
  PERMISSION_ACTION_CODES,
  PERMISSION_RESOURCE_CODES,
} from '@/permissions/definitions';
import { hasActionAccess } from '@/permissions/helpers';

type PortalSwitchProps = {
  collapsed?: boolean;
};

const PortalSwitch: React.FC<PortalSwitchProps> = ({ collapsed = false }) => {
  const access = useAccess() as Record<string, boolean>;
  const pathname = history.location.pathname;
  const isManage = pathname.startsWith('/manage');
  const targetPath = isManage ? '/learn/home' : '/manage/workbench';
  const label = isManage ? '进入员工端' : '进入管理端';
  const currentPortal = isManage ? '当前为管理端' : '当前为员工端';
  const icon = <SwapOutlined className="portal-switch-icon" />;
  const canEnterManage = hasActionAccess(
    access,
    PERMISSION_RESOURCE_CODES.manageEntry,
    PERMISSION_ACTION_CODES.manageEntry.view,
  );

  if (!isManage && !canEnterManage) {
    return null;
  }

  if (collapsed) {
    return (
      <Tooltip placement="right" title={label}>
        <button
          type="button"
          className="portal-switch-btn is-collapsed"
          onClick={() => history.push(targetPath)}
          title={label}
        >
          {icon}
        </button>
      </Tooltip>
    );
  }

  const content = (
    <div className="portal-switch-panel">
      <div className="portal-switch-current">{currentPortal}</div>
      <button
        type="button"
        className="portal-switch-btn"
        onClick={() => history.push(targetPath)}
        title={label}
      >
        {icon}
        <span className="portal-switch-text">{label}</span>
      </button>
    </div>
  );

  return content;
};

export default PortalSwitch;
